import { defineComponent as _defineComponent } from 'vue'
import { ModalData } from '@/models/ModalData';
import type { Reservation } from '@/models/Reservation'
import type { ViewProperties } from '@/models/ViewProperties'
import { ref } from 'vue'
import type { PropType } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsReservation',
  props: {
  res: {
    required: true,
    type: Object as PropType<Reservation>
  },
  viewProperties: {
    required: true,
    type: Object as PropType<ViewProperties>
  },
},
  emits: ['delete-res'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props


const modal = ref(null) as any

// eslint-disable-next-line @typescript-eslint/no-unused-vars


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const del = (reg: Reservation) => {
  const data: ModalData = new ModalData(
    'Entfernen',
    'Möchten Sie diese Reservierung wirklich entfernen? Der Sitz wird danach wieder frei.',
    'Entfernen',
    'Abbrechen',
    reg
  )
  modal.value.showModal(data)
}



// eslint-disable-next-line @typescript-eslint/no-unused-vars
const deleteRes = () => {
  emit('delete-res', props.res)
}


const __returned__ = { modal, props, del, emit, deleteRes, ModalData, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})